<template>
    <vx-selectable placeholder="attribute name"
        :modelValue="props.modelValue"
        label="label"
        :getOptionLabel="(option) => option.label.toLowerCase()"
        :reduce="attribute => attribute.value"
        :options="attributes"
        @update:modelValue="emit('update:modelValue', $event)"
        data-test="attribute-name"
        :error="props.error"
        :clearable="false">
    </vx-selectable>
</template>

<script setup>
import { computed, inject } from 'vue';
import { VxSelectable } from '@voxie/frontend-components';

const FEATURES = inject('FEATURES');

const attributes = computed(() => {
    const options = [
        {
            value: "contacts.first_name",
            label: "First Name"
        },
        {
            value: "contacts.last_name",
            label: "Last Name"
        },
        {
            value: "contacts.email",
            label: "Email"
        },
        {
            value: "contacts.phone",
            label: "Phone Number"
        },
        {
            value: "contacts.phone_state",
            label: "Phone Number State"
        },
        {
            value: "contacts.entry_channel",
            label: "Entry Channel"
        },
        {
            value: "contacts.membership_status",
            label: "Membership Status"
        },
        {
            value: "contacts.lifecycle_status",
            label: "Lifecycle Status"
        },
        {
            value: "contacts.entry_point",
            label: "Entry Point"
        },
        {
            value: "contacts.created_at",
            label: "Created"
        },
        {
            value: "contacts.custom_attributes.key",
            label: "Has Custom Attribute Key"
        },
        {
            value: "contacts.custom_attributes.exclude",
            label: "Does Not Have Custom Attribute Key"
        },
        {
            value: "contacts.custom_attributes.value",
            label: "Has Custom Attribute Value"
        },
        {
            value: "contacts.custom_attributes.created_at",
            label: "Has Custom Attribute Created"
        },
        {
            value: "contacts.custom_attributes.updated_at",
            label: "Has Custom Attribute Updated"
        },
        {
            value: "contacts.custom_attributes.key_value",
            label: "Has Custom Attribute with Key and Value"
        },
        {
            value: "contacts.custom_attributes.exclude_key_value",
            label: "Does Not Have Custom Attribute with Key and Value"
        },
        {
            value: "contacts.tags.tag_name",
            label: "Has Tag"
        },
        {
            value: "contacts.tags.exclude_tags",
            label: "Does Not Have Tag"
        }
    ];

    if (FEATURES.external_contact_lists) {
        options.push({
            value: "contacts.external_contact_lists.membership",
            label: "Is in External List"
        });
        options.push({
            value: "contacts.external_contact_lists.exclude_membership",
            label: "Is Not in External List"
        });
    }

    return options;
});
const props = defineProps({
    modelValue: {
        required: true,
    },
    error: String,
})

const emit = defineEmits(['update:modelValue'])
</script>
